import {GROUPED_BY} from "@constants";


export default function groupedColumn(name, label) {

	return {
		name, label,
		options: {
			headerAlign: 'left'
		}
	}
}